import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarDirective } from './perfect-scrollbar.directive';

export const PERFECT_SCROLLBAR_CONFIG = 'PERFECT_SCROLLBAR_CONFIG';

@NgModule({
  declarations: [PerfectScrollbarDirective],
  imports: [CommonModule],
  exports: [PerfectScrollbarDirective]
})
export class PerfectScrollbarModule {}
